export enum MyDspaceItemStatusType {
  WORKFLOW = 'mydspace.status.workflow',
  VALIDATION = 'mydspace.status.validation',
  WAITING_CONTROLLER = 'mydspace.status.waiting-for-controller',
  WORKSPACE = 'mydspace.status.workspace',
  ARCHIVED = 'mydspace.status.archived',
  DECLINED = 'mydspace.status.declined',
  APPROVED = 'mydspace.status.approved',
}
